import { render, staticRenderFns } from "./resonseHome.vue?vue&type=template&id=38813ff2&scoped=true&"
import script from "./resonseHome.vue?vue&type=script&lang=js&"
export * from "./resonseHome.vue?vue&type=script&lang=js&"
import style0 from "./resonseHome.vue?vue&type=style&index=0&id=38813ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38813ff2",
  null
  
)

export default component.exports